module.exports = __webpack_public_path__ + "assets/icons/logout.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/logout.png
// module id = ./src/styles/icons/sidemenu/logout.png
// module chunks = 0